export default __webpack_public_path__ + "static/media/mobi-ecomerce.e2965d75.png";